import { render, staticRenderFns } from "./MicroeconomicsDetailsPage.vue?vue&type=template&id=1568a530&"
import script from "./MicroeconomicsDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./MicroeconomicsDetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports